/* eslint-disable import/no-extraneous-dependencies */

import { DetailView } from '@pro4-erp/core-web';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import OpenedBrowseView from '../components/OpenedBrowseView';
import FinishedBrowseView from '../components/FinishedBrowseView';

const BrowsePage = () => {
  const { t } = useTranslation();

  return (
    <Box sx={{ mt: 1 }}>
      <DetailView
        childrenSx={{ padding: '2rem' }}
        title={<DetailView.Title>{`${t('Visits', { defaultValue: 'Visits' })}`}</DetailView.Title>}
        tabs={[
          { id: 'opened', title: t('Opened', { defaultValue: 'Opened' }) },
          { id: 'finished', title: t('Finished', { defaultValue: 'Finished' }) },
        ]}
        defaultTab="opened"
      >
        {({ TabContent }) => (
          <>
            <TabContent tab="opened">
              <OpenedBrowseView />
            </TabContent>
            <TabContent tab="finished">
              <FinishedBrowseView />
            </TabContent>
          </>
        )}
      </DetailView>
    </Box>
  );
};

export default BrowsePage;
